import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SettingsRoutingModule } from './settings-routing.module';
import { OverviewComponent } from './overview/overview.component';
import { SettingsService } from './settings.service';
import { FormsModule } from '@angular/forms';
import { SharedModule } from './../shared/shared.module';
import { MDBBootstrapModulesPro  } from 'ng-uikit-pro-standard';
import { VendorComponent } from './vendor/vendor.component';
import { VendorSettingsService } from './vendor-settings.service';

@NgModule({
  imports: [
    CommonModule,
    SettingsRoutingModule,
    FormsModule,
    SharedModule.forRoot(),
    MDBBootstrapModulesPro
  ],
  declarations: [ OverviewComponent, VendorComponent ],
  providers: [ SettingsService, VendorSettingsService ]
})
export class SettingsModule { }
